import { render, staticRenderFns } from "./Sharegateways.vue?vue&type=template&id=4a04a2ae"
import script from "./Sharegateways.vue?vue&type=script&lang=js"
export * from "./Sharegateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports